import { createSlice } from "@reduxjs/toolkit";

export const partnerChannelNameSlice = createSlice({
  name: "channelName",

  initialState: {
    marutiUserDetails: { channelUrl: "", typeOfUI: "", mi_u: "", due: null, customerType: "I",subChannel:""},
    travelUserDetails: {channel: ""},
  },
  reducers: {
    updateMarutiUserDetails: (state, action) => {
      state.marutiUserDetails = {
        ...state.marutiUserDetails,
        ...action.payload,
      };
    },
    updateTravelUserDetails: (state, action)=>{
      state.travelUserDetails = {
        ...state.travelUserDetails,
        ...action.payload,
      };
    }
  },
});

export const {
  channelUrl,
  typeOfUISetter,
  dueDeligenceTxnIdhandler,
  updateMarutiUserDetails,
  updateTravelUserDetails,
} = partnerChannelNameSlice.actions;
export default partnerChannelNameSlice.reducer;
